import { render } from "./SellUsYourVehicle.vue?vue&type=template&id=d64d89da&lang=true"
import script from "./SellUsYourVehicle.vue?vue&type=script&lang=js"
export * from "./SellUsYourVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/SellUsYourVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d64d89da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d64d89da', __exports__)) {
    api.reload('d64d89da', __exports__)
  }
  
  module.hot.accept("./SellUsYourVehicle.vue?vue&type=template&id=d64d89da&lang=true", () => {
    api.rerender('d64d89da', render)
  })

}


export default __exports__